import { Injectable, Provider } from '@angular/core';
import { ProductCategoryService } from 'projects/shared/lib/services/data/product-category/product-category.service';
import { ToastItem } from 'projects/shared/lib/components/shared/toast/item/toast-item.model';
import { EToastItemType } from 'projects/shared/lib/enum/toast/toast-entry-type.enum';
import { EError, ProductCategoryDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { firstValueFrom } from 'rxjs';
import { TreeViewItem } from "projects/shared/lib/components/shared/tree-view/item/tree-view-item.model";
import { ErrorCodeService } from 'projects/shared/lib/services/infrastructure/error-code.service';
import { IProductCategoryServiceToken } from 'projects/shared/lib/services/data/product-category/product-category-service.interface';
@Injectable({
  providedIn: 'root'
})
export class ProductCategoryMHService extends ProductCategoryService {

  public async productCategoryTreeInitAsync(): Promise<void> {
    try {
      this.logger.trace("productCategoryTreeInitAsync(MH) has been called", this.constructor.name);
      let result = await firstValueFrom(this.productCategoryApiService.productCategoryTreeGet());
      let categoryTreeUpdateList: ProductCategoryDto[] | undefined = result.productCategoryList;

      let categoryTreeUpdateNested = this.productCategoryListToTree(categoryTreeUpdateList);
      if (!categoryTreeUpdateNested) {
        categoryTreeUpdateNested = [];
      }

      let categoryTreeCurrentNested = this.categoryTreeViewSource.value;

      let hadCategories = this.categoryTreeIsUsableGet(categoryTreeCurrentNested);
      let hasCategories = this.categoryTreeIsUsableGet(categoryTreeUpdateNested);

      if (hadCategories == true && hasCategories != true) {
        this.logger.trace("productCategoryTreeInitAsync: MyShop is Empty", this.constructor.name);
        this.toastService.toastItemAdd(new ToastItem({
          type: EToastItemType.Warning,
          title: $localize`:@@MyShopAutoDeaktivateToastTitle:MyShop empty`,
          message: $localize`:@@MyShopAutoDeaktivateToastMessage:MyShop doesn't contain items for selection. Automatically deactivated.`,
          code: ErrorCodeService.formatErrorCode(EError.F150011)
        }));
        this.contextService.contextSetDefault();
        return;
      }

      this.categoryTreeViewSource.next(categoryTreeUpdateNested);
    } catch (error) {
      this.logger.error(error, this.constructor.name);
    }

  }

  private categoryTreeIsUsableGet(categoryTree: TreeViewItem[] | undefined) {
    this.logger.trace("categoryTreeIsUsableGet(MH) has been called", this.constructor.name);
    if (categoryTree == undefined || categoryTree.length <= 0) {
      return false;
    }

    let hasSubCategories = categoryTree.some(
      (category) =>
        category.children != undefined && category.children.length > 0
    );
    let hasProducts = categoryTree.some(
      (category) =>
        category.productCount > 0
    );

    return hasSubCategories || hasProducts;
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ProductCategoryMHServiceProvider: Provider[] = [
  { provide: IProductCategoryServiceToken, useExisting: ProductCategoryMHService }
];
